export default {
  common: {
    loading: '로딩 중',
    confirm: '확인',
    cancel: '취소',
    save: '저장',
    back: '뒤로가기',
    copy: '복사',
    delete: '삭제',
    copySuccess: '복사 완료',
    editSuccess: '수정 완료',
    deleteSuccess: '삭제 완료',
    modifySuccess: '변경 완료',
    cannotBeEmpty: '비워둘 수 없습니다',
    noContent: '내용이 없습니다',
    noData: '관련 데이터가 없습니다',
    noMoreData: '더 이상 데이터가 없습니다',
    iKnow: '알겠습니다',
    selectService: '서비스 제공업체 선택',
    sendSuccess: '전송 성공',
  },
  billHome: {
    recharge: '충전 및 납부',
    coupon: '쿠폰',
    rechargeNow: '지금 충전하기',
    cost: '통화료',
    flow: '데이터',
    rechargeNotice: '충전 안내',
    rechargeCost: '통화료 충전',
    rechargeFlow: '데이터 충전',
    rechargeAmount: '충전 금액',
    rechargePackage: '충전 상품',
    discount: '할인 적용됨',
    confirmTxt: '내용 확인',
    confirmTxt1: '확인했습니다',
    actualPayment: '실결제 금액',
    selectCoupon: '쿠폰 선택',
    useRule: '이용 규칙',
    availableCoupon: '사용 가능한 쿠폰',
    unavailableCoupon: '사용 불가능한 쿠폰',
    noAvailableCoupon: '사용 가능한 쿠폰이 없습니다',
    selectPhone: '전화번호 선택',
    pleaseInputPhone: '전화번호 입력',
    couponCount: '개 사용 가능',
    pleaseInputCorrectPhone: '올바른 전화번호를 입력하세요',
    pleaseSelectPackage: '충전 상품을 선택하세요',
  },
  accountManage: {
    title: '계정 관리',
    edit: '편집',
    deleteConfirm: '삭제하시겠습니까?',
  },
  rechargeDetail: {
    title: '결제 내역',
    continuePay: '결제 계속하기',
  },
  feesExpense: {
    title: '납부 기록',
    recharge: '휴대폰 요금',
    electricity: '전기 요금',
    internet: '인터넷 요금',
    water: '수도 요금',
    photo: '사진 찍기',
    complete: '완료',
    manage: '관리',
    allSelect: '전체 선택',
    selected: '선택됨',
    deleteConfirm: '',
    deleteRecord: '개의 납부 기록을 삭제하시겠습니까?',
    noDataAction: '처리할 데이터가 없습니다',
    pleaseSelect: '삭제할 항목을 선택하세요',
    feesNotice: '납부 전 확인사항',
  },
  formCom: {
    upload: '업로드 클릭',
    saveAccount: '기존 계정 저장 또는 업데이트',
    createOrder: '주문 생성',
    rechargeIng: '충전 중',
    rechargeNow: '지금 충전하기',
    serviceProvider: '서비스 제공업체',
    billImage: '청구서 이미지',
    returnSelect: '뒤로 가서 다시 선택',
    electricity: '전기요금',
    internet: '인터넷 요금',
    water: '수도요금',
    photo: '사진으로 납부',
    life: '생활 요금',
    uploadFail: '업로드 실패, 다시 시도하세요',
    pleaseFill: '모든 정보를 입력해 주세요',
    submitSuccess: '제출 완료, 결제 대기 중',
  },
  langPop: {
    selectLang: '언어 선택',
  },
  loginPop: {
    loginOrRegister: 'Kuaizi 계정으로 로그인 또는 가입하세요',
    confirmLogout: '로그아웃 하시겠습니까?',
    toLogin: '로그인 하기',
    logoutSuccess: '로그아웃 완료',
  },
  newMe: {
    myOrder: '내 주문',
    coupon: '쿠폰',
    accountManage: '계정 관리',
    orderCount: '건 진행 중',
    couponCount: '장',
    account: '계정',
    logout: '로그아웃',
  },
  coupons: {
    all: '전체',
    coupon: '쿠폰',
    historyCoupon: '이전 쿠폰',
    use: '사용하기',
    validityPeriod: '유효기간',
    useRule: '이용 규칙',
    used: '사용됨',
    expired: '만료됨',
  },
  accountSeting: {
    title: '설정',
    personalInfo: '개인 정보',
    modifyPayPassword: '결제 비밀번호 변경',
    modifyLoginPassword: '로그인 비밀번호 변경',
    phone: '휴대폰 번호',
    code: '인증번호',
    loginPassword: '로그인 비밀번호',
    confirmModify: '변경 확인',
    noCode: '인증번호가 오지 않나요?',
    passwordPlaceholder: '8~16자의 영문+숫자 조합',
    inputCorrectPhone: '유효한 번호를 입력하세요',
    afterGetCode: '초 후 다시 받기 가능',
    getCode: '인증번호 받기',
    input6DigitPassword: '6자리 숫자 비밀번호 입력',
    twoInputPasswordNotConsistent: '비밀번호가 일치하지 않습니다',
    placeholderCode: '인증번호 입력',
    confirmPassword: '비밀번호 확인',
    password: '비밀번호',
    submit: '제출',
    avatar: '프로필 사진',
    userName: '사용자 이름',
    nickName: '닉네임',
    modifyPhone: '휴대폰 번호 변경',
    nickNamePlaceholder: '나만의 개성을 표현하세요',
    sex: '성별',
    male: '남성',
    female: '여성',
    email: '이메일',
    emailPlaceholder: '비밀번호 찾기를 위해 이메일을 설정하세요',
    pleaseCompletePersonalData: '개인 정보를 입력하시면 더 많은 기능을 이용할 수 있습니다',
    bindNewPhone: '새 휴대폰 번호 등록',
    oldPhone: '이전 휴대폰 번호',
    completeVerification: '인증 완료',
    changePayPasswordTitle: '결제 비밀번호 변경',
    changePasswordTitle: '비밀번호 변경',
    oldPhoneTitle: '기존 번호 인증',
    editInfoTitle: '프로필 수정',
    areaCode: '지역 번호',
  },
}
